import Image from "next/image";
import Link from "next/link";
import { BusinessProvider } from "../../contexts/business-context";

const OnboardingShell = ({ children }) => {
  return (
    <BusinessProvider>
      <div
        className={`grid h-[100dvh] overflow-y-scroll scrollbar-none custom-bg-white-200 content-between pt-[55px] lg:pb-[65px] pb-[30px] `}
      >
        <div className="">
          <Image
            src="/images/logo.svg"
            height={100}
            width={100}
            alt="Logo"
            className="lg:h-[49px] lg:w-[146px] self-start justify-self-center mx-auto block dark:hidden"
          />
          <Image
            src="/images/white-logo.svg"
            height={100}
            width={100}
            alt="Logo"
            className="lg:h-[49px] lg:w-[146px] self-start justify-self-center mx-auto hidden dark:block"
          />
        </div>
        <div className="grid mt-20 w-full px-[24px] lg:px-0 lg:justify-self-center self-start">
          <div className="grid max-w-[630px] justify-self-center w-full z-50">
            <div className="grid max-w-[402px] justify-self-center w-full text-center">
              {children}
            </div>
          </div>
        </div>
        <div className="mx-auto mt-[50px] lg:mt-[100px] w-fit right-0 left-0 flex justify-center gap-[20px] align-self-end">
          <Link href='/terms-and-conditions' target='_blank'>
            <span className="text-[11px] custom-text-grey-300  poppins-regular">
              Privacy & Terms
            </span>
          </Link>
        </div>
      </div>
    </BusinessProvider>
  );
};

export default OnboardingShell;
